interface Taric {
  id: number,
  value: string | null,
  code: string | null,
  description: string,
  parentId: number,
  selected: boolean,
}

interface TaricNode extends Taric {
  children: [],
}

export const initialTaricCodesState = {
  tarics: [],
  taricTree: []
};

export interface ITaricCodesState {
  tarics: Taric[],
  taricTree: TaricNode[]
}
